module.exports = __webpack_public_path__ + "media/images/default/join_us/druggist-9899cd33095d86d5dcf5f6ab28c9cb27.jpg";